import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { EMPTY_ARRAY, EMPTY_OBJECT } from 'invision-core/src/constants/common.constants';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import i18n from 'invision-core/src/components/i18n/i18n';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { UOM_CATEGORIES } from '../../../src/customercare.constants';
var EntitlementBalanceUpdateModalStoreSelector = function EntitlementBalanceUpdateModalStoreSelector(state) {
  return state.customercare.entitlementBalanceUpdateModal;
};
export var IsLoadingEntitlementBalancesSelector = createImmutableSelector([EntitlementBalanceUpdateModalStoreSelector], function (entitlementBalances) {
  return entitlementBalances.isLoading;
});
export var ServiceEntitlementsSelector = createImmutableSelector([EntitlementBalanceUpdateModalStoreSelector], function (entitlementBalances) {
  return entitlementBalances.data.ServiceEntitlementBalances ? entitlementBalances.data.ServiceEntitlementBalances : EMPTY_ARRAY;
});
export var SharedEntitlementsSelector = createImmutableSelector([EntitlementBalanceUpdateModalStoreSelector], function (entitlementBalances) {
  return entitlementBalances.data.SharedEntitlementBalances ? entitlementBalances.data.SharedEntitlementBalances : EMPTY_ARRAY;
});
export var SelectedEntitlementSelector = createImmutableSelector([EntitlementBalanceUpdateModalStoreSelector], function (store) {
  return store.selectedEntitlement || EMPTY_OBJECT;
});
export var UnitOfMeasuresSelector = createImmutableSelector([MetadataCodeTypeDictionarySelector(CODES.UnitsOfMeasure), SelectedEntitlementSelector], function (unitOfMeasures, selectedEntitlement) {
  var _Object$values, _Object$values$find, _Object$values$find$A;
  var unitOfMeasuresOptions = [{
    label: i18n.translate(CoreLocaleKeys.SELECT),
    value: null
  }];
  var selectedEntitlementUomCategory = (_Object$values = Object.values(unitOfMeasures)) === null || _Object$values === void 0 ? void 0 : (_Object$values$find = _Object$values.find(function (unitOfMeasure) {
    return selectedEntitlement.BalanceUnitCode === unitOfMeasure.Value;
  })) === null || _Object$values$find === void 0 ? void 0 : (_Object$values$find$A = _Object$values$find.AdditionalProperties) === null || _Object$values$find$A === void 0 ? void 0 : _Object$values$find$A.category;
  return Object.keys(unitOfMeasures).length && selectedEntitlementUomCategory ? unitOfMeasuresOptions.concat(Object.values(unitOfMeasures).filter(function (uom) {
    if (selectedEntitlementUomCategory === UOM_CATEGORIES.DATA_UNIVERSAL) {
      return uom.AdditionalProperties.category.includes('Data');
    } else if (selectedEntitlementUomCategory === UOM_CATEGORIES.DATA_IT || selectedEntitlementUomCategory === UOM_CATEGORIES.DATA_SCIENTIFIC || selectedEntitlementUomCategory === UOM_CATEGORIES.DATA_TELCO) {
      return uom.AdditionalProperties.category === selectedEntitlementUomCategory || uom.AdditionalProperties.category === UOM_CATEGORIES.DATA_UNIVERSAL;
    } else {
      return uom.AdditionalProperties.category === selectedEntitlementUomCategory;
    }
  }).map(function (unit) {
    return {
      label: selectedEntitlementUomCategory === UOM_CATEGORIES.DATA_UNIVERSAL ? "".concat(unit.AdditionalProperties.short_name, "\xA0\xA0").concat(unit.Description) : unit.AdditionalProperties.short_name,
      value: convertStringToNumber(unit.Value)
    };
  })) : EMPTY_ARRAY;
});